import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UserSessionService } from '@core/services/user-session.service';

const TENANT_HEADER = 'X-Tenant-Id';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(UserSessionService);
  const tenantId = session.user()?.tenantId?.trim();
  if (!tenantId) return next(req);

  // Avoid overriding if caller already specified a tenant explicitly.
  if (req.headers.has(TENANT_HEADER)) return next(req);

  return next(
    req.clone({
      setHeaders: {
        [TENANT_HEADER]: tenantId,
      },
    }),
  );
};

